import Button from "@/components/atom/Button";
import Input from "@/components/atom/Input";
import InputTitle from "@/components/sub-atom/InputTitle";
import Label from "@/components/sub-atom/Label";
import {
  addMitra,
  getAllSellerLevel,
  getGroupArea,
} from "@/functions/databaseData";
import handleErrorAPI, { checkErrorMsg } from "@/functions/handleErrorAPI";
import useAlert from "@/functions/useAlert";
import useHeader from "@/functions/useHeader";
import { RefreshSvg } from "@/public/svg";
import { useRouter } from "next/navigation";
import phone from "phone";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { twMerge } from "tailwind-merge";
import { useQuery } from "@tanstack/react-query";

export default function TambahJaringan() {
  const { showAlert } = useAlert();
  const router = useRouter();
  const { session } = useHeader();
  const [forms, setForms] = useState({});
  const [errors, setErrors] = useState({});

  const [hidePw, setHidePw] = useState(true);
  const [showDropdown, setShowDropdown] = useState({
    key: false,
  });
  const [area, setArea] = useState({
    province: [],
    city: [],
    district: [],
    sub_district: [],
  });

  const handleChange = (name) => (value) => {
    if (
      name == "telephone" &&
      (value.startsWith("0") || value.startsWith("62"))
    ) {
      value = "+62" + value.slice(2);
    }
    setForms((form) => ({
      ...form,
      [name]: value,
    }));
  };

  const handleChangeError = (name) => (value) => {
    setErrors((error) => ({
      ...error,
      [name]: value,
    }));
  };

  async function handleSave() {
    const settingToast = {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    };

    let formatPhone = forms?.telephone?.replace(/[\s-]/g, "");
    if (
      !phone(!formatPhone?.startsWith("+") ? `+${formatPhone}` : formatPhone)
        ?.isValid
    ) {
      handleChangeError("telephone")("No Telephone tidak valid");
      return toast.error("No Telephone tidak valid", settingToast);
    }
    if (!forms?.alamat?.kelurahan?.id) {
      handleChangeError("telephone")("");
      handleChangeError("alamat")("Silahkan masukkan alamat jaringan anda");
      return toast.error("Alamat tidak lengkap", settingToast);
    }
    if (!forms?.password) {
      handleChangeError("telephone")("");
      handleChangeError("alamat")("");
      handleChangeError("password")("Masukkan password atau generate otomatis");
      return toast.error("Password missing", settingToast);
    } else if (forms?.password?.length < 8) {
      handleChangeError("telephone")("");
      handleChangeError("alamat")("");
      handleChangeError("password")("Password must be at least 8 characters");
      return toast.error(
        "Password must be at least 8 characters",
        settingToast
      );
    }
    try {
      const { username, email, password, address, name_store } = forms || {};
      const payload = {
        area_id: forms?.alamat?.kelurahan?.id,
        mitra_upline: session?.user?.data?.mitra_id,
        mitra_id: ``,
        level: forms?.level?.id,
        username,
        email,
        telephone: formatPhone,
        password,
        address,
        name_store,
        longitude:0,
        latitude:0
      };
      const res = await addMitra({
        body: payload,
        token: session?.user?.token,
      });
      console.log(res);
      if (!res?.error) {
        setErrors({});
        router.back();
        return showAlert({
          colors: "success",
          title: "Jaringan Baru Berhasil Ditambahkan",
          desc: "Anda berhasil menambahkan Jaringan baru.",
          handleClick: {
            open: {
              onClick: () => {},
              text: "Tutup",
              hide: false,
            },
            close: {
              onClick: () => {},
              text: "tetap di halaman ini!",
              hide: true,
            },
          },
        });
      } else {
        const stateError = [
          "username",
          "telephone",
          "email",
          "password",
          "name_store",
          "mitra_level",
          "area_id",
          "mitra_id",
          "address",
          "latitude",
          "longitude"
        ];
        handleErrorAPI(res?.error, setErrors, stateError);
        const key = checkErrorMsg(res.error.message, stateError);
        return toast.error(`Error : ${key}`, settingToast);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleDropdown(state) {
    setShowDropdown((old) => ({ ...old, [state]: !showDropdown?.[state] }));
  }

  function generateKey() {
    let length = 8;
    let charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    setForms((old) => ({ ...old, password: retVal }));
  }

  useEffect(() => {
    run();
  }, [
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan,
  ]);

  const run = useCallback(async () => {
    try {
      const payload = {
        province: forms?.alamat?.provinsi?.id,
        city: forms?.alamat?.kabupaten,
        district: forms?.alamat?.kecamatan,
      };
      !forms?.alamat?.provinsi?.id && delete payload?.province;
      !forms?.alamat?.kabupaten && delete payload?.city;
      !forms?.alamat?.kecamatan && delete payload?.district;

      const data_area = await getGroupArea(payload);
      const thisvalue =
        area?.province?.length <= 0
          ? "province"
          : area?.city?.length <= 0
          ? "city"
          : area?.district?.length <= 0
          ? "district"
          : "sub_district";
      setArea((old) => ({ ...old, [thisvalue]: data_area }));
    } catch (error) {
      console.log(error.message);
    }
  }, [
    area,
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan,
  ]);

  const {
    data: listLevelMitra,
    isLoading: loadLevelMitra,
    error: errorLevelMitra,
  } = useQuery({
    queryKey: ["list-mitra-level"],
    queryFn: async () => {
      try {
        const res = await getAllSellerLevel({
          token: session?.user?.token,
        });
        return res ?? [];
      } catch (error) {
        console.log(error.message);
        return [];
      }
    },
    refetchOnWindowFocus: false,
  });

  const filterTextArea = {
    province: forms?.alamat?.provinsi?.title,
    city: forms?.alamat?.kabupaten,
    district: forms?.alamat?.kecamatan,
    sub_district: forms?.alamat?.kelurahan?.title,
  };

  const isArea = (params) => {
    return area?.[params]
      ?.map((item, index) => ({
        id: item?.province_id
          ? item?.province_id
          : item?.area_id
          ? item?.area_id
          : index,
        title: item?.province_name
          ? item?.province_name
          : item?.city_name
          ? item?.city_name
          : item?.district_name
          ? item?.district_name
          : item?.subdistrict_name,
      }))
      .filter((item) =>
        !filterTextArea?.[params]
          ? item
          : item?.title
              .toLowerCase()
              ?.includes(filterTextArea?.[params]?.toLowerCase())
      );
  };

  const listFormDataJaringan = [
    {
      key: "username",
      fieldDB: "username",
      placeholder: "Masukkan nama lengkap",
      label: "Nama Lengkap",
      typeInput: "text",
    },
    {
      key: "email",
      fieldDB: "email",
      placeholder: "Masukkan email",
      label: "Email",
      typeInput: "text",
    },
    {
      key: "telephone",
      fieldDB: "telephone",
      placeholder: "+62xxxxxxxxxxx",
      label: "No. Telp",
      typeInput: "text",
    },
    {
      key: "name_store",
      fieldDB: "name_store",
      placeholder: "Masukkan nama toko",
      label: "Nama Toko",
      typeInput: "text",
    },
  ];

  const listFormAlamatJaringan = [
    {
      key: "provinsi",
      keyArea: "province",
      placeholder: "Pilih Provinsi",
      label: "Provinsi",
      valueDropdown: forms?.alamat?.provinsi?.title,
      zIndex: 5,
      defaultState: {
        id: 0,
        title: "",
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
        };
      },
      alamatFieldKosong: {
        kabupaten: "",
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        city: [],
        district: [],
        sub_district: [],
      },
    },
    {
      key: "kabupaten",
      keyArea: "city",
      disabled: !forms?.alamat?.provinsi,
      placeholder: "Pilih Kabupaten",
      label: "Kabupaten",
      valueDropdown: forms?.alamat?.kabupaten,
      zIndex: 4,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        district: [],
        sub_district: [],
      },
    },
    {
      key: "kecamatan",
      keyArea: "district",
      disabled: !forms?.alamat?.kabupaten,
      placeholder: "Pilih Kecamatan",
      label: "Kecamatan",
      valueDropdown: forms?.alamat?.kecamatan,
      zIndex: 3,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        sub_district: [],
      },
    },
    {
      key: "kelurahan",
      keyArea: "sub_district",
      disabled: !forms?.alamat?.kecamatan,
      placeholder: "Pilih Kelurahan",
      label: "Kelurahan",
      valueDropdown: forms?.alamat?.kelurahan?.title,
      zIndex: 2,
      defaultState: {
        id: 0,
        title: "",
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
        };
      },
      alamatFieldKosong: {},
      areaFieldKosong: {},
    },
  ];

  const listFormAkunJaringan = [
    {
      key: "kode_jaringan",
      placeholder: "JA9820123912312",
      label: "Kode Jaringan",
      typeInput: "text",
      disable: true,
      footerText:
        "Note: Kode Jaringan akan di-Generate oleh sistem (tidak bisa diubah), dan akan dijadikan sebagai identitas Jaringan seterusnya",
    },
    // {
    //   key: "status_kemitraan",
    //   placeholder: "Pilih status kemitraan",
    //   label: "Status Kemitraan",
    //   variants: "dropdown",
    //   zIndex: 5,
    //   handleDropdown: {
    //     datas: [
    //       {
    //         id: 1,
    //         title: "Online",
    //       },
    //       {
    //         id: 2,
    //         title: "Offline",
    //       },
    //     ],
    //     show: showDropdown?.status_kemitraan,
    //     showHIdden: () => handleDropdown(`status_kemitraan`),
    //     onChange: (value) => handleChange("status_kemitraan")(value),
    //     value: forms?.status_kemitraan,
    //   },
    // },
    {
      key: "level",
      placeholder: "pilih level kemitraan",
      label: "Level Kemitraan",
      variants: "dropdown",
      zIndex: 4,
      handleDropdown: {
        datas: listLevelMitra
          ?.filter(
            (val) => val?.id > session?.user?.data?.mitra_level && val?.id != 5
          )
          ?.map((val) => ({ ...val, title: val?.mitra_name }))
          ?.filter((item) =>
            !forms?.level?.title
              ? item
              : item?.title
                  .toLowerCase()
                  ?.includes(forms?.level?.title?.toLowerCase())
          ),

        show: showDropdown?.level,
        showHIdden: () => {
          setForms((old) => ({
            ...old,
            level: {
              id: 0,
              title: "",
            },
          }));
          handleDropdown(`level`);
        },
        onChange: (value) => handleChange("level")(value),
        value: forms?.level,
      },
    },
  ];

  return (
    <div className='flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8 gap-4 xs:gap-8'>
      {/* Data Jaringan */}
      <div className='flex justify-between'>
        <p className='subheading-semiBold text-greyscaleGON-400'>
          Data Jaringan
        </p>
      </div>
      <div className='relative flex flex-col gap-4'>
        {listFormDataJaringan?.map((item, index) => (
          <Input
            key={index}
            onChange={handleChange(item?.key)}
            value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
            disabled={item?.disable}
            placeholder={item?.placeholder}
            label={item?.label}
            error={!errors?.[item?.key] ? false : true}
            caption={errors?.[item?.key]}
            type={item?.typeInput}
            variants={item?.variants}
            handleDropdown={item?.handleDropdown}
            icon={item?.handleIcon}
          />
        ))}
      </div>

      {/* Alamat Jaringan */}
      <div className='flex flex-col'>
        <p className='subheading-semiBold text-greyscaleGON-400'>
          Alamat Jaringan
        </p>
        {errors?.alamat?.length > 0 && (
          <p className='text-errorGON-400 text-button-medium'>
            {errors?.alamat}
          </p>
        )}
      </div>
      <div className='relative flex flex-col gap-4'>
        <div className='flex flex-col gap-4'>
          {/* Detail Alamat */}
          <Input
            onChange={handleChange("address")}
            value={forms?.address}
            placeholder={"Masukkan detail alamat"}
            label={"Detail Alamat"}
            variants='textarea'
            error={!errors?.address ? false : true}
            caption={errors?.address}
          />
          {listFormAlamatJaringan?.map((item, index) => (
            <div
              key={index}
              className={twMerge(`z-[${item?.zIndex}]`)}>
              <Input
                value={item?.valueDropdown}
                placeholder={item?.placeholder}
                disabled={item?.disabled}
                label={item?.label}
                onChange={(value) => {
                  setForms((old) => ({
                    ...old,
                    alamat: {
                      ...old?.alamat,
                      [item?.key]: item?.changeState(value),
                    },
                  }));
                }}
                size='small'
                variants='dropdown'
                handleDropdown={{
                  show: showDropdown?.[`alamat_${item?.key}`],
                  showHIdden: () => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        [item?.key]: item?.defaultState,
                      },
                    }));
                    handleDropdown(`alamat_${item?.key}`);
                  },
                  datas: isArea(item?.keyArea),
                  onChange: (value) => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        ...item?.alamatFieldKosong,
                        [item?.key]: item?.changeState(value),
                      },
                    }));
                    setArea((old) => ({
                      ...old,
                      ...item?.areaFieldKosong,
                    }));
                  },
                  value: item?.valueDropdown,
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Akun Jaringan */}
      <div className='flex justify-between'>
        <p className='subheading-semiBold text-greyscaleGON-400'>
          Akun Jaringan
        </p>
      </div>
      <div className='relative flex flex-col gap-4'>
        {listFormAkunJaringan?.map((item, index) => (
          <div
            className={twMerge("flex flex-col gap-2", `z-[${item?.zIndex}]`)}
            key={index}>
            <Input
              onChange={handleChange(item?.key)}
              value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
              disabled={item?.disable}
              placeholder={item?.placeholder}
              label={item?.label}
              error={!errors?.[item?.key] ? false : true}
              caption={errors?.[item?.key]}
              type={item?.typeInput}
              handleDropdown={item?.handleDropdown}
              icon={item?.handleIcon}
              variants={item?.variants ?? "input"}
            />
            {item?.footerText && (
              <Label
                title={item?.footerText}
                colors='warning'
              />
            )}
          </div>
        ))}

        <InputTitle title={"Password"} />
        <div className='flex flex-col gap-4'>
          <div className='flex flex-col xs:flex-row gap-4 xs:items-center'>
            <div className='items-start'>
              <Input
                onChange={handleChange("password")}
                value={forms?.password}
                placeholder={"AxASd!*(&#"}
              />
            </div>
            <Button
              label='Generate Password'
              icon={{
                left: (props) => <RefreshSvg {...props} />,
              }}
              colors='secondary'
              variants='outline'
              size='small'
              onClick={() => generateKey()}
            />
          </div>
          {errors?.password?.length > 0 && (
            <p className='text-errorGON-400 text-button-medium'>
              {errors?.password}
            </p>
          )}
          <Label
            title={
              "Note: Harap untuk mencatat Password diatas dan berikan ke Jaringan!"
            }
            colors='warning'
          />
        </div>
      </div>

      <div className='flex flex-col xs:flex-row gap-4 xs:items-center justify-end'>
        <div className='items-start'>
          <Button
            label='Batal'
            variants='outline'
            onClick={() => {
              setForms({});
              router.back();
            }}
          />
        </div>
        <div className='items-start'>
          <Button
            label='Tambah Jaringan'
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
}
